export default "__VITE_ASSET__CZHBl2T2__"